import { el } from "@dhx/ts-common/dom";
import { IListConfig, ListEvents, IListItem } from "../types";
import { List } from "../List";

export class InputEditor {
	protected _handlers: { [key: string]: (...args) => void };
	protected _mode: boolean;
	protected _config: IListConfig;
	protected _list: List;
	protected _item: IListItem;
	protected _input: HTMLInputElement;

	constructor(item: any, list: List) {
		this._list = list;
		this._config = list.config;
		this._item = item;
		this._list.events.on(ListEvents.focusChange, (index, id) => {
			if (this._mode && id !== this._item.id) {
				this.endEdit();
			}
		});
		this._initHandlers();
	}
	endEdit() {
		if (this._input) {
			const value = this._input.value;
			if (this._list.events.fire(ListEvents.beforeEditEnd, [value, this._item.id])) {
				this._input.removeEventListener("blur", this._handlers.onBlur);
				this._input.removeEventListener("change", this._handlers.onChange);
				this._handlers = {};
				this._mode = false;

				this._list.events.fire(ListEvents.afterEditEnd, [value, this._item.id]);
			} else {
				this._input.focus();
			}
		}
	}
	toHTML() {
		this._mode = true;
		const { itemHeight } = this._config;
		return el(".dhx_input__wrapper", { role: "presentation" }, [
			el("div.dhx_input__container", { role: "presentation" }, [
				el("input.dhx_input", {
					class: this._item.css ? " " + this._item.css : "",
					style: {
						height: itemHeight,
						width: "100%",
						padding: "8px 12px",
					},
					_hooks: {
						didInsert: this._handlers.didInsert,
					},
					_key: this._item.id,
					dhx_id: this._item.id,
				}),
			]),
		]);
	}
	protected _initHandlers() {
		this._handlers = {
			onBlur: () => {
				this.endEdit();
			},
			onChange: () => {
				this.endEdit();
			},
			didInsert: (node?: any) => {
				const input = node.el;
				this._input = input;
				input.focus();
				input.value = this._item.value;
				input.setSelectionRange(0, input.value.length);
				input.addEventListener("change", this._handlers.onChange);
				input.addEventListener("blur", this._handlers.onBlur);
			},
		};
	}
}
